import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import Iframe from "react-iframe";
import { useForm } from "react-hook-form";
import Button from "../../Component/Button";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { sendContactUs } from "./Slice/contactUsSlice";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

const Index = (props) => {

  const dispatch = useDispatch();
  const { actions, title } = props;
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const setting = useSelector((state) => state?.setting);
  const { successMessage, loading } = useSelector(
    (state) => state.contactUs
  );
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const siteName = setting?.name?.trim() || "Contact Us";

  useEffect(() => {
    const title = `${siteName} - Contact Us`;
    document.title = title;

    const fetchData = () => {
      window.scrollTo(0, 0);
      document.querySelector('meta[name="description"]').setAttribute('content', "Would like to be a mentor or mentee with us? Queries? Concerns?  Get in touch with us and we will be happy to assist you with your inquiries.");

    };
    fetchData();
  }, [siteName, actions, title]);

  const onSubmit = async (data) => {
    try {
      await dispatch(sendContactUs(data)).unwrap();

      setPopupMessage(
        successMessage || "Your message has been sent successfully."
      );
      setShowPopup(true);
      reset();
    } catch (err) {
      setPopupMessage(
        err?.message || "Failed to send message. Please try again."
      );
      setShowPopup(true);
    }
  };

  return (
    <>
      <section className="outer_main contactboxoutertab">
        <Container className="page_heading text-center">
          <h1>Contact Us </h1>
        </Container>
        <div className="contactUs">
          <Container>
            <div className="contactinner">
              <Row>
                <Col md={6}>
                  <h3 className="subHeading">{setting.contactus_heading || "Quick enquiry"}</h3>
                  <p>{setting.contactus_subheading || "Reach out to us for any inquiry"}</p>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    {/* Name Field */}
                    <Form.Group controlId="formBasicFirstName" className="mb-4">
                      <FormControl
                        type="text"
                        placeholder="Name*"
                        className={errors?.name ? "formError" : ""}
                        {...register("name", {
                          required: "Please enter your name",
                          minLength: {
                            value: 3,
                            message: "Your name should contain at least 3 characters",
                          },
                          maxLength: {
                            value: 20,
                            message: "Your name should contain max 20 characters",
                          },
                          pattern: {
                            value: /^[A-Za-z ]+$/,
                            message: "Only alphabets and spaces are allowed",
                          },
                          validate: (value) =>
                            value.trim() ? true : "Whitespace not allowed",
                        })}
                        aria-invalid={errors?.name ? "true" : "false"}
                      />
                      {errors.name && (
                        <span role="alert" style={{ color: "red" }}>
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>

                    {/* Email Field */}
                    <Form.Group controlId="formBasicEmail" className="mb-4">
                      <FormControl
                        type="email"
                        placeholder="Email Address*"
                        className={errors?.email ? "formError" : ""}
                        {...register("email", {
                          required: "Please enter your email address",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                          maxLength: {
                            value: 50,
                            message: "Your email should contain max 50 characters",
                          },
                        })}
                        aria-invalid={errors?.email ? "true" : "false"}
                      />
                      {errors.email && (
                        <span role="alert" style={{ color: "red" }}>
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>

                    {/* Message Field */}
                    <Form.Group controlId="formBasicMessage" className="mb-4">
                      <FormControl
                        as="textarea"
                        rows={3}
                        placeholder="Message*"
                        className={errors?.message ? "formError" : ""}
                        {...register("message", {
                          required: "Please enter your message",
                          minLength: {
                            value: 5,
                            message: "Your message should contain at least 5 characters",
                          },
                          maxLength: {
                            value: 500,
                            message: "Message should not exceed more than 500 characters",
                          },
                          validate: (value) =>
                            value.trim() ? true : "Whitespace not allowed",
                        })}
                        aria-invalid={errors?.message ? "true" : "false"}
                      />
                      {errors.message && (
                        <span role="alert" style={{ color: "red" }}>
                          {errors.message.message}
                        </span>
                      )}
                    </Form.Group>

                    <Button
                      title={loading ? "Submitting..." : "Submit"}
                      type="submit"
                      className="link_btn btn btn_red shadow-2 mb-4 w-30"
                      disabled={loading}
                    >

                    </Button>
                  </Form>
                </Col>
                <Col md={6}>
                  <div className="map position-relative">
                    <Iframe
                      url={`https://www.google.com/maps?q=${encodeURIComponent(setting?.address)}&z=14&output=embed`}
                      width="100%"
                      height="550px"
                      id="myId"
                      className="myClassname"
                      display="initial"
                      position="relative"
                      frameBorder="0"
                    />
                  </div>
                </Col>
              </Row>
              <div className="contact_info">
                <div className="locate">
                  <img src="/assets/images/location.png" alt="Locations" />
                  <h4>
                    Location <span dangerouslySetInnerHTML={{ __html: setting?.address?.replaceAll("\r\n", "<br>") }}></span>
                  </h4>
                </div>

                <div className="locate">
                  <img src="/assets/images/email.png" alt="email" />
                  <h4>
                    Email: <span>{setting.support_email}</span>
                  </h4>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </section>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Index.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.object,
};

export default Index;
